import { fetchFactory } from 'Libs/http/utils';
import { filterEmptyValues } from 'Libs/object/filter-empty-values';

import type { ContentSearchPayload, SearchContentsResponse } from './types';

export const searchContentsFn = async ({ offset, limit, filters }: ContentSearchPayload) => {
  const { fetchFn } = fetchFactory<SearchContentsResponse>({
    route: `/api/back-office/contents?${new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
      ...filterEmptyValues(filters),
    }).toString()}`,
    method: 'GET',
  });

  return await fetchFn();
};
